import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      isShow: false
    },
    tools_app: localStorage.getItem('app'),
    appType: localStorage.getItem('appType'),
    visitedViews: []
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    // 是否显示菜单
    SET_SIDEBAR_SHOW: (state, value) => {
      if(value) {
        state.sidebar.isShow = true
      } else {
        state.sidebar.isShow = false
      }
    },
    SET_TOOLS_APP: (state, value) => {
      if(value) {
        state.tools_app = value
      }
    },
    SET_APP_TYPE: (state, value) => {
      if(value) {
        state.appType = value
      }
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) return
      state.visitedViews.push({ name: view.name, path: view.path })
    },
    DEL_VISITED_VIEWS: (state, view) => {
      let index
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          index = i
          break
        }
      }
      state.visitedViews.splice(index, 1)
    }
  },
  actions: {
    ToggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    addVisitedViews({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    setSidebarShow({ commit }, isShow) {
      commit('SET_SIDEBAR_SHOW', isShow)
    },
    setToolsApp({ commit }, value) {
      commit('SET_TOOLS_APP', value)
    },
    setAppType({ commit }, value) {
      commit('SET_APP_TYPE', value)
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js